export default __webpack_public_path__ + "dist/media/Avtar.d3790dd6.svg";